import {FlowComponent, FlowSection} from '@mintdata-wsp/common/state/ui/visualDesigner/FlowState';
import {WSPIcon} from '@mintdata-wsp/resources/icons/WSPIcon';
import {WSPIcons, WSPIconSize} from '@mintdata-wsp/resources/icons/WSPIcons';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {
    CloudComponentPreview,
    CloudComponentPreviewMode
} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/panels/components/CloudComponentPreview';
import * as classnames from 'classnames/bind';
import {action} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./FlowSectionView.less');
const cx = classnames.bind(styles);

export interface FlowSectionHeaderProps
{
    section:FlowSection;
}

@observer
export class FlowSectionView extends React.Component<FlowSectionHeaderProps, any>
{
    @action.bound
    private _toggleSectionExpansion()
    {
        const {section} = this.props;
        section.isExpanded = !section.isExpanded;
    }

    private _renderHeader()
    {
        const {section} = this.props;

        return  <Row className={cx('sectionHeader')} onClick={this._toggleSectionExpansion}>
                    {/*<Row>*/}
                        {
                            section.isExpanded?
                                <WSPIcon className={cx('collapseExpandIcon')}
                                         name={WSPIcons.visualDesigner.panels.headers.ArrowDown}
                                         size={WSPIconSize.medium20}/>
                                :
                                <WSPIcon className={cx('collapseExpandIcon')}
                                         name={WSPIcons.visualDesigner.panels.headers.ArrowRight}
                                         size={WSPIconSize.medium20}/>
                        }
                    {/*</Row>*/}
                    <Row>
                        <b> {section.sectionName}</b>
                    </Row>
                    {/*<Row>
                        {section.artifactName}
                    </Row>*/}
                </Row>;
    }

    render()
    {
        const {section} = this.props;
        const isVisible = section.hasVisibleComponents;
        const isExpanded = section.isExpanded;
        const filterString = controllers.ui.flowComponentsPanel.getFilterString();

        return  <Column key={section.id} className={cx('sectionColumn',
                                                       {'visible'    : isVisible},
                                                       {'notVisible' : !isVisible},
                                                       )}>
                    {this._renderHeader()}
                    <Row className={cx('componentsRow',
                                       {'visible'    : isExpanded},
                                       {'notVisible' : !isExpanded},
                                       )}>
                        {
                            section.components.map((fc:FlowComponent)=>
                            {
                               return  <CloudComponentPreview key={fc.component.id}
                                                              isVisible={fc.isVisible}
                                                              highlightNamePart={filterString}
                                                              component={fc}
                                                              mode={CloudComponentPreviewMode.IconBlock}/>;
                            })
                        }
                    </Row>
                </Column>;
    }
}
